import { PageResult } from "./PageResult";

//Vuetify Datatable

export class DataTable<T> {
    public loading: boolean
    public expand: boolean
    public headers: Header[]
    public options: DatatableOptions

    public totalItemsCount: number
    public itemsPerPageOptions = [25, 50, 100]

    constructor(_loading: boolean, _expand: boolean, _headers: Header[], _options: DatatableOptions) {
        this.loading = _loading;
        this.expand = _expand;
        this.headers = _headers;
        this.options = _options;
    }

    updatePagination(pageObj: PageResult<T>) {
        this.totalItemsCount = pageObj != undefined ? pageObj.totalCount : 0;
    }

    updateTable() {
        this.options.handler();
    }
}

export class DatatableOptions {
    public page?: number
    public itemsPerPage?: number
    public sortBy?: string[]
    public sortDesc?: string[]
    public groupBy?: string[]
    public groupDesc?: string[]
    public mustSort?: boolean
    public multiSort?: boolean

    public handler: () => Promise<void>
}

export class Header {
    public text: string
    public value: string
    public align: Align
    public sortable: boolean
    public class: string[] | string
    public width: string

    constructor(_text: string, _value: string, _align: Align, _sortable: boolean, _class: string[] | string, _width: string) {
        this.text = _text;
        this.value = _value;
        this.align = _align;
        this.sortable = _sortable;
        this.class = _class;
        this.width = _width;
    }
}

export enum Align {
    left = "left",
    center = "center",
    right = "right"
}
